<script lang="ts">
	import { PUBLIC_CDN_URL } from '$env/static/public';
	import Button from '$lib/components/ui/button/button.svelte';
</script>

<div
	class="flex h-screen w-screen flex-col items-center justify-center gap-12 overflow-hidden px-8 text-center"
>
	<div class="flex flex-col items-center justify-center gap-4 text-center">
		<h1 class="px-2 text-5xl lg:text-5xl">Whoops!</h1>
		<p class="max-w-lg text-base text-lightTertiary">
			<span class="text-purple-400">We apologize for the inconvenience</span>. It seems you've
			encountered an error or requested a page that doesn't exist.
		</p>
		<p class="max-w-lg text-base text-lightTertiary">
			Rest assured, our team is on the case and working diligently to resolve the issue as quickly
			as possible.
		</p>
	</div>
	<img
		src={`${PUBLIC_CDN_URL}/meeko/meeko_error.png?fm=webp`}
		class="absolute bottom-0 h-auto w-[700px] cursor-pointer"
		alt="Meeko"
	/>
	<Button href="/">Go back to home</Button>
</div>
